module.exports = __webpack_public_path__ + "img/10.88c8c4c5.jpg";